import { useEffect, useState } from 'react';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { HelmetComponent } from '../../components/Helmet';
import { List, ListItem } from '../../components/List';
import { useAuth } from '../../hooks/useAuth';

import { Markup } from 'interweave';
import { useNavigate } from 'react-router-dom';
import _ from 'underscore';
import * as routes from '../../constants/Routes';
import { api } from '../../server/api';
import moment from 'moment';
interface INotifications {
  notificationType: any;
  notificationTitle: string;
  notificationContent: string;
  createdAt: number;
  scope?: string;
  sended?: boolean;
  playersWhoRead: object;
}

export function Notifications() {
  const navigate = useNavigate();
  const {
    client,
    getNotifications,
    notifications,
    player,
    notificationCategory1,
    notificationCategory2,
  } = useAuth();

  const [allNotifications, setAllNotifications] = useState<
    Array<INotifications>
  >([]);

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    const allNotificationsList =
      notificationCategory1 &&
      notificationCategory1.concat(notificationCategory2);

    setAllNotifications(_.sortBy(allNotificationsList, 'createdAt').reverse());
  }, [notifications]);

  const updateReadNotifications = async (notification: any) => {
    const parameters = {
      updateFunctionality: 'updateReadNotifications',
      userType: 'player',
      playerId: player.id,
      notificationId: notification.id,
      clientId: client.id,
    };

    await api
      .post(`/update`, parameters)
      .then(() => {
        getNotifications();
      })
      .catch((error) => {
        console.log('updateReadNotifications error:', error);
      });
  };
  const handleRedirectNotification = (notification: any) => {
    if (['newAction', 'newQuiz'].includes(notification.notificationType)) {
      const actionId = notification.metadata?.actionId || notification.actionId;
      if (actionId) {
        return navigate(`${routes.ACTION_DETAILS}/${actionId}`);
      }
    }
    if (notification.notificationType === 'newRescue') {
      return navigate(`${routes.MY_RESCUES}`);
    }
    if (
      ['newLead', 'newConversionLead', 'advancedStepLead'].includes(
        notification.notificationType
      )
    ) {
      const leadId = notification.metadata?.leadId;
      return navigate(
        leadId
          ? `${routes.MY_INDICATIONS}?leadId=${leadId}`
          : `${routes.MY_INDICATIONS}`
      );
    }
    if (notification.notificationType === 'newKnowledgeTrail') {
      const knowledgeTrailId = notification.metadata?.knowledgeTrailId;
      return navigate(
        knowledgeTrailId
          ? `${routes.KNOWLEDGE_TRAIL}/${knowledgeTrailId}`
          : `${routes.KNOWLEDGE_TRAIL}`
      );
    }
    if (notification.notificationType === 'membergetmember') {
      return navigate(`${routes.PROSPECTS}`);
    }
    if (notification.notificationType === 'newPoints') {
      return navigate(`${routes.REDEEM_AWARDS}`);
    }
    if (
      ['postValidationApproved', 'postValidationRejected'].includes(
        notification.notificationType
      )
    ) {
      const publicationId = notification.metadata?.publicationId;
      if (publicationId) {
        return navigate(`${routes.POST_VALIDATION}/${publicationId}`);
      }
    }
  };

  const scopsActions = [
    'newAction',
    'newLead',
    'newRescue',
    'newConversionLead',
    'membergetmember',
    'newPoints',
    'newKnowledgeTrail',
    'newQuiz',
    'postValidationApproved',
    'postValidationRejected',
  ];

  return (
    <>
      <HelmetComponent
        clientLogoURL={client.logoURL}
        companyName={client.companyName}
        clientFavicon={client.favIcon}
        tabTitle={'Notificações'}
      />
      <div className="container">
        <div className="d-flex align-items-center my-3">
          <i className="material-icons-outlined me-3 color-text">
            notifications_active
          </i>
          <span className="fs-4">Notificações</span>
        </div>
        <div className="my-3">
          {/* Nessa primeira categoria mostra os 10 primeiros */}
          <Card>
            <List>
              {allNotifications &&
                allNotifications.length > 0 &&
                allNotifications.map(
                  (notification: INotifications, index: number) => {
                    return (
                      <ListItem
                        icon="notifications"
                        key={index}
                        content={
                          <Markup
                            content={`<div><p class="fw-semibold m-0 ${
                              (notification.scope === 'direct' &&
                                !notification.sended) ||
                              (!notification.playersWhoRead && 'opacity-50')
                            }" >${
                              notification.notificationTitle
                            }</p >  <p class="${
                              (notification.scope === 'direct' &&
                                !notification.sended) ||
                              !notification.playersWhoRead
                                ? 'm-0 fw-semibold'
                                : 'm-0'
                            }">${
                              notification.notificationContent
                            }</p> <p class="m-0">${moment(
                              notification.createdAt
                            ).format('DD/MM/YYYY HH:mm')}</p></div>`}
                          />
                        }
                        onClick={() => {
                          if (
                            (notification.scope === 'direct' &&
                              !notification.sended) ||
                            !notification.playersWhoRead
                          ) {
                            updateReadNotifications(notification);
                          }
                        }}
                        secondaryContent={
                          <>
                            {notification &&
                              scopsActions.includes(
                                `${notification.notificationType}`
                              ) && (
                                <Button
                                  text=""
                                  icon="arrow_forward_ios"
                                  onClick={() =>
                                    handleRedirectNotification(notification)
                                  }
                                />
                              )}
                          </>
                        }
                      />
                    );
                  }
                )}
              {allNotifications && allNotifications.length === 0 && (
                <ListItem
                  icon="notifications_paused"
                  content="Nenhuma notificação"
                />
              )}
            </List>
          </Card>
        </div>
      </div>
    </>
  );
}
